module.exports = __webpack_public_path__ + "static/media/process_5.d7544e26.png";